var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgramBookIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1585_44433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.25 6.25C24.8625 5.8125 23.3375 5.625 21.875 5.625C19.4375 5.625 16.8125 6.125 15 7.5C13.1875 6.125 10.5625 5.625 8.125 5.625C5.6875 5.625 3.0625 6.125 1.25 7.5V25.8125C1.25 26.125 1.5625 26.4375 1.875 26.4375C2 26.4375 2.0625 26.375 2.1875 26.375C3.875 25.5625 6.3125 25 8.125 25C10.5625 25 13.1875 25.5 15 26.875C16.6875 25.8125 19.75 25 21.875 25C23.9375 25 26.0625 25.375 27.8125 26.3125C27.9375 26.375 28 26.375 28.125 26.375C28.4375 26.375 28.75 26.0625 28.75 25.75V7.5C28 6.9375 27.1875 6.5625 26.25 6.25ZM26.25 23.125C24.875 22.6875 23.375 22.5 21.875 22.5C19.75 22.5 16.6875 23.3125 15 24.375V10C16.6875 8.9375 19.75 8.125 21.875 8.125C23.375 8.125 24.875 8.3125 26.25 8.75V23.125Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.875 13.125C22.975 13.125 24.0375 13.2375 25 13.45V11.55C24.0125 11.3625 22.95 11.25 21.875 11.25C19.75 11.25 17.825 11.6125 16.25 12.2875V14.3625C17.6625 13.5625 19.625 13.125 21.875 13.125Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 15.6125V17.6875C17.6625 16.8875 19.625 16.45 21.875 16.45C22.975 16.45 24.0375 16.5625 25 16.775V14.875C24.0125 14.6875 22.95 14.575 21.875 14.575C19.75 14.575 17.825 14.95 16.25 15.6125Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.875 17.9126C19.75 17.9126 17.825 18.2751 16.25 18.9501V21.0251C17.6625 20.2251 19.625 19.7876 21.875 19.7876C22.975 19.7876 24.0375 19.9001 25 20.1126V18.2126C24.0125 18.0126 22.95 17.9126 21.875 17.9126Z",
    fill: "#EBEBEB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1585_44433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramBookIcon);
export default __webpack_public_path__ + "static/media/ProgramBookIcon.09742fad2c4edfc675875ff99c0b3fe7.svg";
export { ForwardRef as ReactComponent };